import { QueryClient } from '@tanstack/react-query';
import { ApiProblem } from './problem';

/**
 * One QueryClient policy for both SPAs: reads retry only on network/5xx problems (never on 4xx — a 403 or 404 does not
 * get better by retrying); commands (mutations) never retry automatically — the user decides, with the same
 * idempotency key.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) =>
          failureCount < 2 && (!(error instanceof ApiProblem) || error.status === 0 || error.status >= 500),
      },
      mutations: { retry: false },
    },
  });
}
